import type { MigrationContextSummary } from "../api/migration";
import { isUsableReturnUrl } from "../utils/buildReturnUrl";
import { sourceApplicationDisplayName } from "../utils/sourceApplicationDisplayName";

/** Steps shown by the registration wizard: no welcome, no review screen. */
export const REGISTRATION_STEPS = ["Verify e-mail", "Password", "Done"];

/** True when the application sent a person who has just registered with it */
export function isRegistration(
  context: MigrationContextSummary | null | undefined
): boolean {
  return context?.flow === "registration";
}

/** The application name shown to the person: its display name, else its code. */
export function applicationName(
  context: MigrationContextSummary | null | undefined
): string {
  return (
    context?.app_display_name ||
    sourceApplicationDisplayName(context?.source_application)
  );
}

/**
 * Where "Sign in to that account" goes: the application's login page, else the
 * root of the origin it returns to; null when neither is known.
 */
export function applicationLoginUrl(
  context: MigrationContextSummary | null | undefined
): string | null {
  if (context?.login_url) {
    return isUsableReturnUrl(context.login_url) ? context.login_url : null;
  }
  if (!context?.return_url || !isUsableReturnUrl(context.return_url)) {
    return null;
  }
  return new URL(context.return_url).origin;
}

/** Where "Wrong e-mail? Back to …" goes; null when absent or not usable (same guard as return_url). */
export function applicationCancelUrl(
  context: MigrationContextSummary | null | undefined
): string | null {
  return context?.cancel_url && isUsableReturnUrl(context.cancel_url)
    ? context.cancel_url
    : null;
}
